/** tempexp_14728-full-file */
import classNames from 'clsx';
import React, { memo } from 'react';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from './ItemName.css';

interface ItemNameProps {
    className?: string;
    name: string;
    ext?: string;
    loading?: boolean;
}

export const ItemName = memo<ItemNameProps>(function ItemName({ className, loading, name, ext }) {
    return (
        <div
            className={classNames(styles.root, className, {
                [styles.loading]: loading,
            })}
        >
            <NameComponent name={name} extension={ext} truncate showTooltip />
        </div>
    );
});
